import React from "react";
import Tabs from "react-bootstrap/lib/Tabs";
import Tab from "react-bootstrap/lib/Tab";
import Notices from "./Notices";
import NoticeCategories from "./NoticeCategories";

const NoticesTab = props =>
  <Tabs defaultActiveKey={1} id="notices_tab">
    <Tab eventKey={1} title="Notices">
      <Notices />
    </Tab>
    <Tab eventKey={2} title="Categories">
      <NoticeCategories />
    </Tab>
  </Tabs>;

export default NoticesTab;



// WEBPACK FOOTER //
// ./src/components/NoticesTab.js